import Authentication from 'containers/Authentication'


import Login from 'scenes/Login'
import PasswordRecovery from 'scenes/PasswordRecovery'
import SetPassword from 'scenes/SetPassword'

const routes = {
  path: '/accounts',
  container: Authentication,

  routes: {
    login: {
      path: '/login',
      requiresAuth: false,
      component: Login
    },
    password_recovery: {
      path: '/password-recovery',
      requiresAuth: false,
      component: PasswordRecovery
    },
    password_set: {
      path: '/set-password/:user_id/:token',
      requiresAuth: false,
      component: SetPassword
    }
  }
}

export default routes



// WEBPACK FOOTER //
// ./src/routes/accounts.js